export default __webpack_public_path__ + "static/media/d5.5f641280.png";